import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Seo, localBusinessLD } from "../lib/seo";
import { GALLERY_FALLBACK, CATEGORIES } from "../data/content";
import { Reveal, SectionHead } from "../components/Reveal";
import { PageHero, CtaBand } from "../components/Shared";
import BeforeAfter from "../components/BeforeAfter";

export default function GaleriePage() {
    const [items, setItems] = useState(GALLERY_FALLBACK);
    const [cat, setCat] = useState("tout");

    useEffect(() => {
        api.get("/gallery")
            .then((res) => { if (Array.isArray(res.data) && res.data.length) setItems(res.data); })
            .catch(() => {});
    }, []);

    const shown = cat === "tout" ? items : items.filter((i) => i.category === cat);

    return (
        <>
            <Seo
                title="Galerie chantiers — Avant / Après peinture, parquet & carrelage | Solino Pro"
                description="Galerie avant/après de rénovation intérieure dans le Vexin et l'Oise : peinture, parquet, carrelage, sols vinyles, façades. Devis gratuit sous 48 h."
                path="/galerie"
                jsonld={localBusinessLD()}
            />
            <PageHero
                img={GALLERY_FALLBACK[1].after}
                crumb="Solino Pro — Réalisations"
                title="Des chantiers"
                serif="qu'on assume à 100 %."
            />

            <section className="mx-auto max-w-[1400px] px-5 sm:px-8 py-20 lg:py-28" data-testid="gallery-section">
                <SectionHead
                    eyebrow="Avant / Après"
                    title="Nos vrais chantiers,"
                    serif="à vous de juger."
                    text="Photos prises sur nos chantiers du Vexin : état initial, travaux, résultat final. Ce n'est pas du filtre ou du hasard — c'est de la préparation, du temps et du geste maîtrisé."
                />

                <div className="mt-12 flex flex-wrap gap-2" data-testid="gallery-filters">
                    {CATEGORIES.map((c) => (
                        <button
                            key={c.key}
                            onClick={() => setCat(c.key)}
                            className={`rounded-full px-5 py-2.5 text-sm border transition-all duration-300 ${
                                cat === c.key
                                    ? "bg-gold text-ink border-gold font-bold"
                                    : "border-linew text-ivory/70 hover:border-gold/50 hover:text-gold"
                            }`}
                            data-testid={`gallery-filter-${c.key}`}
                        >
                            {c.label}
                        </button>
                    ))}
                </div>

                <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="gallery-grid">
                    {shown.map((g, i) => (
                        <Reveal key={g.item_id} delay={(i % 3) * 0.07} className={i % 3 === 0 ? "sm:row-span-1" : ""}>
                            {g.before ? (
                                <BeforeAfter before={g.before} after={g.after} title={g.title} location={g.location} />
                            ) : (
                                <figure className="relative overflow-hidden border border-linew group aspect-[4/3]" data-testid={`gallery-item-${g.item_id}`}>
                                    <img
                                        src={g.after}
                                        alt={g.title}
                                        loading="lazy"
                                        className="absolute inset-0 w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-700"
                                    />
                                    <figcaption className="absolute bottom-0 inset-x-0 flex items-end justify-between gap-3 p-5 bg-gradient-to-t from-ink/90 to-transparent">
                                        <span className="text-ivory text-sm">{g.title}</span>
                                        <span className="text-gold text-[10px] uppercase tracking-[0.2em] shrink-0">{g.location}</span>
                                    </figcaption>
                                </figure>
                            )}
                        </Reveal>
                    ))}
                </div>

                {shown.length === 0 && (
                    <p className="mt-16 text-center text-smoke" data-testid="gallery-empty">
                        Aucun chantier dans cette catégorie pour l'instant — demandez-nous des exemples en direct.
                    </p>
                )}
            </section>

            <CtaBand />
        </>
    );
}
